import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminUserDetail from "@/pages/admin/AdminUserDetail";
import AdminPayouts from "@/pages/admin/AdminPayouts";
import AdminSettings from "@/pages/admin/AdminSettings";
import UserLayout from "@/pages/user/UserLayout";
import UserDashboard from "@/pages/user/UserDashboard";
import UserQR from "@/pages/user/UserQR";
import UserPayout from "@/pages/user/UserPayout";
import UserStatement from "@/pages/user/UserStatement";

function Protected({ role, children }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-950 text-white">
        <div className="animate-pulse text-sm">Loading NaxoPay…</div>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to={user.role === "admin" ? "/admin" : "/app"} replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster position="top-right" richColors closeButton />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />

            <Route path="/admin" element={<Protected role="admin"><AdminLayout /></Protected>}>
              <Route index element={<AdminDashboard />} />
              <Route path="users" element={<AdminUsers />} />
              <Route path="users/:id" element={<AdminUserDetail />} />
              <Route path="payouts" element={<AdminPayouts />} />
              <Route path="settings" element={<AdminSettings />} />
            </Route>

            <Route path="/app" element={<Protected role="user"><UserLayout /></Protected>}>
              <Route index element={<UserDashboard />} />
              <Route path="qr" element={<UserQR />} />
              <Route path="payout" element={<UserPayout />} />
              <Route path="statement" element={<UserStatement />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
